import Head from 'next/head';
import { useRouter } from 'next/router';
import React from 'react';
import { textCompiler } from '../../../services/textCompiler';
import { generateReviewStructuredData } from '../../../services/reviewsService';
import { generateFAQStructuredData, shouldDisplayFAQ } from '../../../services/faqService';

interface SeoHeadProps {
  title?: string;
  description?: string;
  variables?: object;
  includeReviews?: boolean;
  includeFAQ?: boolean;
}

export function SeoHead(props: SeoHeadProps): JSX.Element {
  const { asPath } = useRouter();
  // Log pour vérifier l'exécution du composant en production
  console.log('[SeoHead] rendu', {
    asPath,
    title: props.title,
    description: props.description,
    includeReviews: props.includeReviews,
    includeFAQ: props.includeFAQ
  });

  // Logs pour vérifier le contenu des rich snippets
  if (props.includeReviews !== false) {
    const reviewSnippet = generateReviewStructuredData();
    console.log('[SeoHead] review richSnippet', reviewSnippet);
  }
  if (props.includeFAQ !== false && shouldDisplayFAQ(asPath)) {
    const faqSnippet = generateFAQStructuredData(asPath);
    console.log('[SeoHead] FAQ richSnippet', faqSnippet);
  }

  const canonicalUrl = asPath.split('?')[0];

  const title = props.title
    ? textCompiler(props.title, props.variables)
    : process.env.NEXT_PUBLIC_DEFAULT_META_TITLE;
  const description = props.description
    ? textCompiler(props.description, props.variables)
    : process.env.NEXT_PUBLIC_DEFAULT_META_DESCRIPTION;

  // Inclure les avis par défaut, sauf si explicitement désactivé
  const shouldIncludeReviews = props.includeReviews !== false;
  
  // Inclure les FAQ par défaut, sauf si explicitement désactivé
  const shouldIncludeFAQ = props.includeFAQ !== false && shouldDisplayFAQ(asPath);

  return (
    <div>
      <Head>
        <>
          <title>{title}</title>
          <meta name='description' content={description} />
          <meta property='og:title' content={title} key='title' />
          <meta
            property='url'
            content={`${process.env.NEXT_PUBLIC_APP_URL}${asPath}`}
          />
          <meta property='type' content='website' />
          <meta
            property='image'
            content={`${process.env.NEXT_PUBLIC_APP_URL}/logo-orange.jpg`}
          />
          <meta
            property='og:description'
            content={description}
            key='description'
          />
          <meta
            property='og:url'
            content={`${process.env.NEXT_PUBLIC_APP_URL}${asPath}`}
          />
          <meta property='og:type' content='website' />
          <meta
            property='og:image'
            content={`${process.env.NEXT_PUBLIC_APP_URL}/logo-orange.jpg`}
          />
          <link
            rel='canonical'
            href={`${process.env.NEXT_PUBLIC_APP_URL}${canonicalUrl}`}
          />
          
          {/* Rich snippet des avis - JSON-LD */}
          {shouldIncludeReviews && (
            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={{
                __html: JSON.stringify(generateReviewStructuredData())
              }}
            />
          )}
          
          {/* Rich snippet FAQ - JSON-LD */}
          {shouldIncludeFAQ && (
            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={{
                __html: JSON.stringify(generateFAQStructuredData(asPath))
              }}
            />
          )}
        </>
      </Head>
    </div>
  );
}
